import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const BaseballIcon = observer('BaseballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='baseballMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M2.783 12.25a7 7 0 0 1-1.075-1.958A6.5 6.5 0 0 1 1.333 8.1q0-1.133.375-2.192A7 7 0 0 1 2.783 3.95Q3.75 4.7 4.3 5.792q.55 1.091.55 2.308t-.55 2.308a5.35 5.35 0 0 1-1.517 1.842M8 14.767q-1.2 0-2.292-.4A6.5 6.5 0 0 1 3.717 13.2a6.8 6.8 0 0 0 1.8-2.275 6.3 6.3 0 0 0 .65-2.825q0-1.5-.65-2.825A6.8 6.8 0 0 0 3.717 3q.9-.767 1.991-1.167A6.6 6.6 0 0 1 8 1.433q1.2 0 2.292.4A6.5 6.5 0 0 1 12.283 3a6.8 6.8 0 0 0-1.8 2.275 6.3 6.3 0 0 0-.65 2.825q0 1.5.65 2.825a6.8 6.8 0 0 0 1.8 2.275q-.9.767-1.991 1.167t-2.292.4m5.217-2.517a5.35 5.35 0 0 1-1.517-1.842 5.06 5.06 0 0 1-.55-2.308q0-1.216.55-2.308a5.35 5.35 0 0 1 1.517-1.842q.7.9 1.075 1.958t.375 2.192-.375 2.192a7 7 0 0 1-1.075 1.958'
                />
            </mask>
            <g mask='url(#baseballMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
